export default __webpack_public_path__ + "static/media/roboto-v20-latin-300.37a7069d.woff2";